if (!customElements.get("my-accordion")) {
  class MyAccordion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener("toggle", (event) => {
        const targetItem = event.target;
        const items = Array.from(this.querySelectorAll("my-accordion-item"));

        items.forEach((item) => {
          if (item !== targetItem) {
            item.close();
          }
        });
      });
    }
  }

  customElements.define("my-accordion", MyAccordion);
}

if (!customElements.get("my-accordion-item")) {
  class MyAccordionItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headingElement = this.querySelector(".accordion-item__heading");
      this.contentElement = this.querySelector(".accordion-item__body");

      this.headingElement.addEventListener("click", () => {
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));
        this.toggle();
      });

      if (this.classList.contains("active")) {
        this.open();
      } else {
        this.close();
      }
    }

    toggle() {
      if (this.headingElement.getAttribute("aria-expanded") === "true") {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.classList.add("active");
      this.headingElement.setAttribute("aria-expanded", "true");
      this.contentElement.style.maxHeight = `calc(${this.contentElement.scrollHeight}px + var(--accordion-item-padding))`;
    }

    close() {
      this.classList.remove("active");
      this.headingElement.setAttribute("aria-expanded", "false");
      this.contentElement.style.maxHeight = "0";
    }
  }

  customElements.define("my-accordion-item", MyAccordionItem);
}
